import { RouterProvider } from 'react-router';
import { router } from '@/app/router';
import { useAuthBootstrap } from '@/core/auth/useAuthBootstrap';

export const App = (): React.ReactElement => {
  useAuthBootstrap();
  return <RouterProvider router={router} />;
};
